import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserSessionPersistence } from 'firebase/auth'

// import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
import firebaseConfig from './firebaseConfig.js';

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

// Initialize Firebase
initializeApp(firebaseConfig);

// Get the auth instance for the Firebase app
const auth = getAuth(firebaseApp);

// Set the auth persistence to SESSION
setPersistence(auth, browserSessionPersistence)
  .then(() => {
    console.log('Session persistence has been set to "session"');
  })
  .catch((error) => {
    console.error('Failed to set persistence:', error);
  });

// createApp(App).use(router).mount('#app')

createApp(App).use(router).mount('#app');
